import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../../Dashboard/_services/order.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CartService } from '../../../Dashboard/_services/cart.service';

@Component({
    selector: 'app-klarna-confirmation',
    imports: [],
    templateUrl: './klarna-confirmation.component.html',
    styleUrl: './klarna-confirmation.component.css'
})
export class KlarnaConfirmationComponent implements OnInit {
  klarnaSnippet: string = '';
  klarnaIframeUrl: SafeResourceUrl = '';

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private cartService: CartService
  ) {}

  ngOnInit(): void {
    const browserUrl = window.location.href;
    const params = new URLSearchParams(browserUrl.split('?')[1]);
    const orderId = params.get('order_id');
    if (orderId) this.getOrderDetails(orderId);
  }

  onClose() {
    this.router.navigate(['/sales/create']);
  }

  private async getOrderDetails(orderId: any) {
    await this.orderService.getKlarnaDetailsByOrderId(orderId).subscribe({
      next: (response: any) => {
        this.klarnaSnippet = response.html_snippet;
        const blob = new Blob([this.klarnaSnippet], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        this.klarnaIframeUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.cartService.setKlarnaStatus("DONE");
      },
      error: (error: { error: { message: any } }) => console.log(error),
    });
  }
}
